import { ColumnsType } from 'antd/lib/table';
import {
  getReportExportScopeText,
  getReportExportTableData,
  ReportExportMetric,
  ReportExportScope,
  toReportExportCellValue,
} from './report-export-table-data';

interface ExportReportToExcelParams<T> {
  columns: ColumnsType<T>;
  fileName: string;
  metrics: ReportExportMetric[];
  reportTitle: string;
  rows: T[];
  scope: ReportExportScope;
}

export const exportReportToExcel = async <T>({
  columns,
  fileName,
  metrics,
  reportTitle,
  rows,
  scope,
}: ExportReportToExcelParams<T>): Promise<void> => {
  const XLSX = await import('xlsx');
  const { header, rows: tableRows } = getReportExportTableData<T>(
    columns,
    rows,
  );
  const sheetData = [
    [reportTitle],
    [getReportExportScopeText(scope)],
    [],
    ...metrics.map(({ caption, label, value }: ReportExportMetric) => [
      label,
      toReportExportCellValue(value),
      caption ?? '',
    ]),
    [],
    header,
    ...tableRows,
  ];

  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(
    workbook,
    XLSX.utils.aoa_to_sheet(sheetData),
    reportTitle.replace(/[\\/?*[\]:]/g, ' ').slice(0, 31),
  );

  XLSX.writeFile(workbook, fileName);
};
